export default __webpack_public_path__ + "static/media/watches9.2db9fc64.jfif";